export function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_BASE_URL;
}

export function isProduction(): boolean {
  return import.meta.env.VITE_AWS_BRANCH === 'main';
}

export function getEnvName(): string {
  return (import.meta.env.VITE_NODE_ENV || import.meta.env.NODE_ENV) as string;
}

export function getAuth0Audience() {
  return import.meta.env.VITE_AUTH0_AUDIENCE;
}
